import { render, staticRenderFns } from "./DialogImportacao.vue?vue&type=template&id=6a237f9a"
import script from "./DialogImportacao.vue?vue&type=script&lang=js"
export * from "./DialogImportacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports